import React from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  ListGroup,
  ListGroupItem
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDog,
  faCat,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';
import { Switch, Redirect, Route, Link, NavLink } from 'react-router-dom';
import ProductCta from '../../components/ProductCta/ProductCta';
import ProductCtaBar from '../../components/ProductCta/ProductCtaBar';
import pageComponents from './pethelp/';
import './pethelp/pethelp.scss';

const pethelpData = [
  { title: 'Opis', component: 'Ogolne', link: 'opis/', icon: 'medkit' },
  {
    title: 'Zakup pakietu dla psa',
    component: 'PakietDlaPsa',
    link: 'pakiet-dla-psa/',
    icon: faDog,
    isPurchase: true
  },
  {
    title: 'Zakup pakietu dla kota',
    component: 'PakietDlaKota',
    link: 'pakiet-dla-kota/',
    icon: faCat,
    isPurchase: true
  },
  {
    title: 'Jak aktywować',
    component: 'JakAktywowac',
    link: 'jak-aktywowac/',
    icon: 'arrow-alt-circle-right'
  },
  { title: 'Placówki', component: 'Placowki', link: 'placowki/', icon: 'map-marker-alt' },
];

class Pethelp extends React.Component {
  render() {
    let currentBreadcrumb;

    const menu = pethelpData.map((item) => {
      if (
        !currentBreadcrumb &&
        (`${this.props.match.path}${item.link}` === this.props.location.pathname ||
          `${this.props.match.path}${item.link}` ===
            `${this.props.location.pathname}/`)
      ) {
        currentBreadcrumb = <BreadcrumbItem active>{item.title}</BreadcrumbItem>;
      }

      return (
        <ListGroupItem
          tag={NavLink}
          key={item.title}
          to={`${this.props.match.path}${item.link}`}
          className={item.isPurchase ? 'pethelp-nav-item-cta' : ''}
          data-product-cta={item.isPurchase ? '' : undefined}
          action>
          <span className="d-flex align-items-center">
            <FontAwesomeIcon
              fixedWidth
              icon={item.icon}
              style={{ marginRight: '0.5rem' }}
            />
            <span>{item.title}</span>
            {item.isPurchase && (
              <span className="pethelp-nav-item-arrow">
                <FontAwesomeIcon icon={faArrowRight} />
              </span>
            )}
          </span>
        </ListGroupItem>
      );
    });

    const routes = pethelpData.map((item) => (
      <Route
        key={item.link}
        path={`${this.props.match.path}${item.link}`}
        component={pageComponents[item.component]}
      />
    ));

    // Package pages are the purchase step themselves
    const onPurchasePage = pethelpData.some(
      (item) =>
        item.isPurchase &&
        this.props.location.pathname.startsWith(
          `${this.props.match.path}${item.link}`
        )
    );

    return (
      <div className="pethelp-shell">
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/">{this.props.rootSection}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to={this.props.match.path}>{this.props.section}</Link>
          </BreadcrumbItem>
          {currentBreadcrumb}
        </Breadcrumb>

        <Row>
          <Col xs="12" lg="3">
            <div className="pethelp-nav">
              <ListGroup>{menu}</ListGroup>
            </div>
          </Col>
          <Col xs="12" lg="9">
            <Switch>
              {routes}
              <Redirect
                exact
                from={`${this.props.match.path}pakiety/`}
                to={`${this.props.match.path}pakiet-dla-psa/`}
              />
              <Redirect
                exact
                from={`${this.props.match.path}cennik-i-zamowienie/`}
                to={`${this.props.match.path}pakiet-dla-psa/`}
              />
              <Redirect exact from="/pethelp" to="/pethelp/opis/" />
              <Redirect exact from={this.props.match.path} to={`${this.props.match.path}opis/`} />
              <Redirect to={`${this.props.match.path}opis/`} />
            </Switch>
          </Col>
        </Row>
        {!onPurchasePage && (
          <ProductCtaBar title="Pethelp">
            <ProductCta
              to={`${this.props.match.path}pakiet-dla-psa/`}
              icon={faDog}
              compact>
              Pakiet dla psa
            </ProductCta>
            <ProductCta
              to={`${this.props.match.path}pakiet-dla-kota/`}
              icon={faCat}
              compact>
              Pakiet dla kota
            </ProductCta>
          </ProductCtaBar>
        )}
      </div>
    );
  }
}

export default Pethelp;
